import React from 'react';

import BasePage from 'components/Page';
import Content from 'components/Content';

/* About Us page. */
export default class AboutUs extends BasePage {
  render() {
    // parent, for lifecycle logging
    super.render();

    // render
    return <Content name="aboutUs" showError={true} />;
  }
}
